import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es-co/*")({
  head: () => buildRouteHead("/es-co/*", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es", replace: true });
  },
});
